import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { fetchBackgroundbanners } from "../../features/backgroundBannerslice";
import { useSelector, useDispatch } from "react-redux";

const BackgroundBanner = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const debounceTimeout = useRef(null);

  const dispatch = useDispatch();

  const { backgroundbanner, status, error } = useSelector(
    (state) => state.backgroundbanner
  );

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchBackgroundbanners());
    }
  }, [dispatch, status]);

  const handleMouseEnter = (index) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    setHoveredIndex(index); // Set hovered index to the current index
  };

  const handleMouseLeave = () => {
    debounceTimeout.current = setTimeout(() => {
      setHoveredIndex(null);
    }, 50);
  };

  const getLinkUrl = (item) => {
    if (item.select_type == 1) {
      if (item.category_slug && item.subcategory_slug && item.subchildcategory_slug) {
        return `/${item.category_slug}/${item.subcategory_slug}/${item.subchildcategory_slug}`;
      } else if (item.category_slug && item.subcategory_slug) {
        return `/${item.category_slug}/${item.subcategory_slug}`;
      } else if (item.category_slug) {
        return `/${item.category_slug}`;
      }
    } else if (item.select_type == 2) {
      if (item.product_slug) {
        return `/product-details/${item.product_slug}`;
      }
    } else if (item.select_type == 3) {
      if (item.classification_slug) {
        return `/classification_list/${item.classification_slug}`;
      }
    }
  };

  // Slider settings for mobile view
  const sliderSettings = {
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    margin: 8,
    nav: false,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1320,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  if (!backgroundbanner || backgroundbanner.length === 0) return null;

  return (
    <>
      <div className="background-banner-bg pt-40 pb-40">
        <div className="container mainbackground-banner">
          <div className="product-inner">
            <div className="row">
              {backgroundbanner.map((item, index) => (
                <div
                  className="col-lg-3 col-md-6 col-6  grid_col"
                  data-aos="fade-down"
                  key={index}
                >
                  <Link to={getLinkUrl(item)}>
                    <img
                      src={
                        hoveredIndex === index ? item.image[1] : item.image[0]
                      }
                      alt={`image-${index}`}
                      onMouseEnter={() => handleMouseEnter(index)}
                      onMouseLeave={handleMouseLeave}
                    />
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* <div className="background-banner-mobile-bg pt-40 pb-40">
        <div className="container mainbackground-banner">
          <div className="product-inner">
            <Slider {...sliderSettings}>
              {backgroundbanner.map((item, index) => (
                <div className="item" key={index}>
                  <img src={item.image[0]} alt={`img-${index}`} />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default BackgroundBanner;
